import { useEffect, useState } from "react";
import { Content, fetchOneEntry, isPreviewing } from "@builder.io/sdk-react";
import { ActionLink } from "./components/ActionLink";

const apiKey = import.meta.env.VITE_BUILDER_API_KEY;

function BuilderCta({ href, label, secondary }) {
  return (
    <ActionLink href={href} secondary={secondary}>
      {label}
    </ActionLink>
  );
}

const customComponents = [
  {
    component: BuilderCta,
    name: "imajnet CTA",
    inputs: [
      { name: "href", type: "url", required: true },
      { name: "label", type: "text", required: true },
      { name: "secondary", type: "boolean", defaultValue: false },
    ],
  },
];

export function BuilderPage({ locale, children }) {
  const [content, setContent] = useState(undefined);
  const [loaded, setLoaded] = useState(!apiKey);

  useEffect(() => {
    if (!apiKey) return;

    let active = true;
    fetchOneEntry({
      model: "page",
      apiKey,
      userAttributes: { urlPath: window.location.pathname },
      locale,
    })
      .then((entry) => {
        if (active) setContent(entry);
      })
      .catch(() => {
        if (active) setContent(null);
      })
      .finally(() => {
        if (active) setLoaded(true);
      });

    return () => {
      active = false;
    };
  }, [locale]);

  if (!apiKey) return children;
  if (loaded && !content && !isPreviewing()) return children;
  if (!loaded && !isPreviewing()) return <div className="page-loading" />;

  if (content) {
    return (
      <Content
        apiKey={apiKey}
        content={content}
        customComponents={customComponents}
        data={{ locale }}
        locale={locale}
        model="page"
      />
    );
  }

  return children;
}
